import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { isValidPhoneNumber } from 'react-phone-number-input';
import PhoneInput from 'react-phone-number-input';
import { Link } from "gatsby";
import { TrackingData } from './TrackingData';

function GetInTouchForm() {
    const { register, control, watch, handleSubmit, setValue, formState: { errors } } = useForm({
        defaultValues: {
            userLocation: '',
            birthCountry: '',
        },
    });

    const phoneNumber = watch('phoneNumber');
    let isPhoneNumberValid = false;
    let phoneNumberErrorMessage = '';

    if (phoneNumber) {
        const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber);
        if (!parsedPhoneNumber || !isValidPhoneNumber(phoneNumber)) {
            phoneNumberErrorMessage = "Invalid phone number";
        } else if (parsedPhoneNumber.nationalNumber.length < 7) {
            phoneNumberErrorMessage = "At least 7 digits required";
        } else {
            isPhoneNumberValid = true;
        }
    }

    const trackingData = TrackingData();

    useEffect(() => {
        setValue('utm_source', trackingData.utm_source);
        setValue('utm_medium', trackingData.utm_medium);
        setValue('utm_campaign', trackingData.utm_campaign);
        setValue('utm_content', trackingData.utm_content);
        setValue('utm_term', trackingData.utm_term);
        setValue('gclid', trackingData.gclid);
    }, [trackingData, setValue]);
 
    const onSubmit = async (data) => {
        const formDetector = document.querySelector('.netlify-form-detector');
        if (formDetector) formDetector.remove();
    
        data = { ...data, ...trackingData, "form-name": "getInTouchSaudiArabia" };

        const formData = Object.keys(data)
            .filter(key => data[key] !== undefined && data[key] !== null && data[key] !== '')
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
            .join('&');

        console.log('Form data:', formData); // Debug: Log form data

        const response = await fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formData
        });

        if (response.ok) {
            window.location.href = "/thank-you/";
        } else {
            console.error("Form submission failed", response.status, response.statusText); // Debug: Log response status
        }
    };

    const commonClasses = {
        label: "text-xs font-light bg-white relative start-4 top-3 z-10 px-2",
        input: "h-10 mt-1 block w-full px-3 border bg-white shadow-sm focus:outline-none text-sm",
    };

    return (
        <>
            <form name="getInTouchSaudiArabia" method="POST" data-netlify="true" netlify-honeypot="bot-field" onSubmit={handleSubmit(onSubmit)}>
            <input type="hidden" name="form-name" value="getInTouchSaudiArabia" />
            <input type="hidden" name="utm_source" />
            <input type="hidden" name="utm_medium" />
            <input type="hidden" name="utm_campaign" />
            <input type="hidden" name="utm_content" />
            <input type="hidden" name="utm_term" />
            <input type="hidden" name="gclid" />
                <div className="grid grid-cols-1 md:grid-cols-2 md:gap-10 relative">
                    <div>
                        <label htmlFor="firstName" className={`${commonClasses.label} ${errors.firstName ? 'text-holborn-red' : ''}`}>What is your first name?*</label>
                        <input
                            id="firstName"
                            {...register("firstName", { required: "This field is required" })}
                            name="firstName"
                            type="text"
                            placeholder="e.g. John"
                            className={`${commonClasses.input} ${errors.firstName ? 'border-holborn-red' : ''}`}
                        />
                    </div>

                    <div className="mt-2 md:mt-0">
                        <label htmlFor="lastName" className={`${commonClasses.label} ${errors.lastName ? 'text-holborn-red' : ''}`}>What is your last name?*</label>
                        <input
                            id="lastName"
                            {...register("lastName", { required: "This field is required" })}
                            name="lastName"
                            type="text"
                            placeholder="e.g. John"
                            className={`${commonClasses.input} ${errors.lastName ? 'border-holborn-red' : ''}`}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 mt-2 md:gap-10 lg:mt-4 relative">
                    <div>
                        <label htmlFor="email" className={`${commonClasses.label} ${errors.email ? 'text-holborn-red' : ''}`}>What is your email address?*</label>
                        <input
                            id="email"
                            {...register("email", {
                                required: "This field is required",
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Invalid email address"
                                }
                            })}
                            name="email"
                            type="email"
                            placeholder="john@example.com"
                            className={`${commonClasses.input} ${errors.email ? 'border-holborn-red' : ''}`}
                        />
                    </div>
                    <div className="md:col-span-1 mt-2 md:mt-0">
                        <label htmlFor="phoneNumber" className={`${commonClasses.label} ${errors.phoneNumber ? 'text-holborn-red' : ''}`}>What is your mobile number?</label>
                        <Controller
                            control={control}
                            name="phoneNumber"
                            rules={{ required: true }}
                            render={({ field: { onChange, onBlur, name, ref, value } }) => (
                                <PhoneInput
                                    id="phoneNumber"
                                    international
                                    defaultCountry="SA"
                                    value={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    name={name}
                                    inputRef={ref}
                                    aria-label="Phone number"
                                    className={`${commonClasses.input} ${errors.email ? 'border-holborn-red' : ''}`}
                                />
                            )}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 mt-8 lg:mt-10 relative">
                    <label htmlFor="additionalInfo" className="text-xs font-light bg-white absolute start-4 -top-1 z-10 px-2">Would you like to add anything?</label>
                    <textarea 
                        id="additionalInfo"
                        className="mt-1 block w-full h-24 p-4 border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-holborn-blue-500 sm:text-sm text-holborn-blue resize-none"
                        name="additionalInfo"
                        {...register("additionalInfo")} 
                        placeholder="Any additional information you would like to include on your enquiry?">
                    </textarea>
                </div>
                <div className="pt-6 justify-center flex">
                    <div className="button-wrapper items-center justify-center inline-block w-auto">
                        <p className="hidden">
                            <label>
                                Don't fill this out if you're human: <input name="bot-field" />
                            </label>
                        </p>
                        
                        <input type="hidden" name="_redirect" value="/thank-you/" />
                        <div className="col-span-12 text-center">
                            <button className="py-2 px-8 rounded-3xl transition duration-500 text-holborn-white bg-holborn-green hover:bg-holborn-blue" type="submit">Send Enquiry</button>
                        </div>
                    </div>
                </div>
                <p className="text-center text-xs pt-2">By submitting this form, you agree to our <Link className="font-bold hover:underline" to="/privacy-notice">Privacy Policy</Link></p>
            </form>
        </>
    );
}

export default GetInTouchForm;